export default __webpack_public_path__ + "static/media/1396-01_1399-01 (painted).511ca984.jpg";